import React from 'react';
import { Image } from 'semantic-ui-react';
import Typography from 'src/components/coreUI/Typography';

type Props = {
  avatarUrl?: string;
  name?: string;
  tags?: string[];
  date?: string;
};

const PersonInfo: React.FC<Props> = (props) => {
  const { avatarUrl, name, date } = props;

  return (
    <div className="d-flex justified my-24 align-center">
      <div>
        <Image size="huge" avatar src={avatarUrl} />
      </div>
      <div>
        <Typography.Paragraph className="mb-0">{name}</Typography.Paragraph>
        <Typography.Paragraph>{date}</Typography.Paragraph>
      </div>
    </div>
  );
};

export default PersonInfo;
